<template>
  <div class="flex-page">
    <a-form
      class="form"
      :label-col="formItemLayout.labelCol"
      :wrapper-col="formItemLayout.wrapperCol"
    >
      <a-form-item label="上传文件">
        <UploadFile @callback="uploaded" :mult="false" folder="auction" />
        <p>上传Excel数据文件
          <a :href="API+ '/auctionDemo.xlsx'"><a-button size="small" style="margin-left: 20px">下载</a-button></a></p>
      </a-form-item>
      <a-form-item label="图片文件夹">
        /home/wwwroot/default/img/<a-input style="width: 200px" placeholder="" v-model="form.folder" />
        <p>例如：Auction2022，注意大小写</p>
      </a-form-item>
      <a-form-item label="起拍价">
        <a-input-number :min="0" v-model="form.price" /> 元
      </a-form-item>
      <a-form-item label="说明">
        <p>图片放在FTP的/home/wwwroot/default/img下，自建文件夹</p>
        <p>将文件夹名填写在上面“图片文件夹”输入框</p>
        <p>图片名与编号相同，图片后缀名必须是.jpg</p>
        <p>起拍价可以修改</p>
        <p>注意各个输入框的大小写</p>
      </a-form-item>
    </a-form>
    <div class="buttons">
      <a-button type="primary" @click="sub">批量上传</a-button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import UploadFile from '../../../components/uploadFile.vue'

export default {
  components: { UploadFile },
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 3,
        },
        wrapperCol: {
          span: 20,
        },
      },
      form: {
        auc_id: null,
        file: "",
        folder: "",
        price: 1
      }
    };
  },
  created () {
    this.form.auc_id = this.$route.query.auc_id;
  },
  methods: {
    moment,
    uploaded(file) {
      this.form.file = file.file_path;
    },
    async sub() {
      if (!this.form.auc_id) return this.$message.error('未获取到拍卖场次');
      if (!this.form.file) return this.$message.error('请上传文件');
      if (!this.form.folder) return this.$message.error('请填写图片文件夹');
      if (!this.form.price) return this.$message.error('请填写起拍价');

      const r = await this.$axios.post("/auction/goods/import", this.form);
      if(r.status == 1){
        this.$router.back()
      }
    }
  },
};
</script>